import React from 'react';

const TermsOfService = () => {
  return (
    <div className="bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow p-8">
          <h1 className="text-4xl font-bold mb-2">Terms of Service</h1>
          <p className="text-gray-500 mb-8">Last updated: February 2026</p>

          <div className="prose max-w-none text-gray-600 space-y-6">

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-3">1. Acceptance of Terms</h2>
              <p>
                By accessing or using ContractGuard ("the Service") at contractguard.com.au, you agree
                to be bound by these Terms of Service. If you do not agree, please do not use the Service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-3">2. Not Legal Advice</h2>
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                <p className="font-semibold text-gray-800 mb-2">Important Disclaimer</p>
                <p>
                  ContractGuard provides AI-powered contract analysis for informational purposes only.
                  The Service does not constitute legal advice and should not be relied upon as such.
                  Always consult with a qualified solicitor or lawyer before making any legal decisions
                  or signing any contracts.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-3">3. Use of the Service</h2>
              <p className="mb-2">You agree to use the Service only for lawful purposes. You must not:</p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>Upload documents you do not have the right to share</li>
                <li>Attempt to reverse engineer or compromise the Service</li>
                <li>Use the Service to infringe on any third party's rights</li>
                <li>Resell or redistribute the Service without written permission</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-3">4. Accounts</h2>
              <p>
                You are responsible for maintaining the security of your account credentials. You must
                notify us immediately of any unauthorised access to your account. We reserve the right
                to suspend or terminate accounts that violate these terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-3">5. Payments and Subscriptions</h2>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>All prices are in Australian Dollars (AUD) unless stated otherwise</li>
                <li>Subscriptions are billed monthly and renew automatically</li>
                <li>You may cancel your subscription at any time from your Account page</li>
                <li>No refunds are provided for partial months of service</li>
                <li>Pay Per Scan purchases are non-refundable once used</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-3">6. Intellectual Property</h2>
              <p>
                All content, features, and functionality of the Service are owned by ContractGuard and
                protected by Australian and international copyright laws. You retain ownership of the
                documents you upload.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-3">7. Limitation of Liability</h2>
              <p>
                To the maximum extent permitted by law, ContractGuard shall not be liable for any
                indirect, incidental, or consequential damages arising from your use of the Service.
                Our total liability shall not exceed the amount you paid for the Service in the 3 months
                prior to the claim.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-3">8. Governing Law</h2>
              <p>
                These Terms are governed by the laws of Australia. Any disputes shall be subject to
                the exclusive jurisdiction of the courts of Australia.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-3">9. Contact</h2>
              <p>
                For questions about these Terms, contact us at:{' '}
                <a href="mailto:admin@contractguard.com.au" className="text-primary-600 hover:text-primary-700">
                  admin@contractguard.com.au
                </a>
              </p>
            </section>

          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
